import * as React from "react";
import User from "../../../../model/user/User";
import "./userInitials.scss"

interface IProps {
	user: User;
	isActive?: boolean;
}

export default class UserInitials extends React.Component<IProps, {}> {

	render() {
		return (
			<div className={"c-user-initials"}>
				{this.props.user.getInitials()}
				{this.props.isActive && <div className={"c-user-initials_status"}/>}
			</div>
		)
	}
}